/**
 * Keep HTTP(S) destinations, including relative references, using the browser's
 * URL parser. A scheme regex misses C0 controls and embedded tabs/newlines that
 * browsers strip before navigation. The fixed base performs no I/O and leaves
 * resolution of relative references to the page when the attribute is used.
 *
 * Return the original trimmed spelling: DOM attributes do not HTML-decode
 * entities, and percent-decoding here would change a harmless relative path
 * into a different destination.
 */
export const safeUrl = (url: string): string | undefined => {
	const trimmed = url.trim();
	if (trimmed === "") return undefined;
	try {
		const { protocol } = new URL(trimmed, "https://markdown.invalid/");
		return protocol === "http:" || protocol === "https:" ? trimmed : undefined;
	} catch {
		return undefined;
	}
};
